import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    const login = async () => {
      await loginWithRedirect({
        appState: {
          returnTo: "/",
        },
        fragment: "register",
      });
    };
    login();
    return <div>Redirecting...</div>;
  } else {
    navigate("/");
  }

  return <></>;
};

export default Register;
